export default __webpack_public_path__ + "static/media/jp.efb06262.svg";